import React, { useState } from "react";
import Drawer from "@mui/material/Drawer";
import IconButton from "@mui/material/IconButton";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import { AddIcon, EditIcon, MoreHorizIcon } from "../../../components";
import { useStyles } from "./MobileDrawer.styles";
import { history } from "../../../lib";

import { useSelector } from "react-redux";
import { adminSelectors } from "../../../state";
import { NODE_ENV } from "../../../config";

export default function MobileDrawer() {
  const classes = useStyles();

  const { applicant, quoteTypes, quoteType, agency } = useSelector(
    adminSelectors.activeQuote,
  );

  const urlMode = quoteTypes.includes("AutoRenters")
    ? "auto-renters"
    : quoteType.toLowerCase();
  const hydrateLink = `${
    NODE_ENV !== "development"
      ? `https://${agency?.domain}`
      : `http://${window.location.host}`
  }/${urlMode}/wizard/hydrate-quote/${applicant.req_uid}`;

  const [state, setState] = useState({
    bottom: false,
  });

  const items = [
    {
      text: "Edit in wizard",
      icon: <EditIcon />,
      showItem: quoteType !== "manual",
      func: () => window.open(`${hydrateLink}`, "_blank"),
    },
    {
      text: "Edit application",
      icon: <EditIcon />,
      showItem: quoteType === "manual",
      func: () => history.push(`/admin/edit-application/${applicant.req_uid}`),
    },
    {
      text: "Add manual application",
      icon: <AddIcon />,
      showItem: true,
      func: () => history.push("/admin/create-application"),
    },
  ];

  const filteredItems = items.filter((i) => !!i.showItem);

  const toggleDrawer =
    (open: boolean) => (event: React.KeyboardEvent | React.MouseEvent) => {
      if (
        event.type === "keydown" &&
        ((event as React.KeyboardEvent).key === "Tab" ||
          (event as React.KeyboardEvent).key === "Shift")
      ) {
        return;
      }

      setState({ bottom: open });
    };

  const setDrawerOpen = (reason) => {
    if (reason === "backdropClick") {
      setState({ bottom: false });
    }
  };

  const list = () => {
    return (
      <div className={classes.list} role="presentation">
        <List>
          {filteredItems.map((item) => (
            <ListItem
              button
              key={item.text}
              className={classes.listItem}
              onClick={() => {
                setState({ bottom: false });
                item.func?.();
              }}
            >
              <ListItemIcon>{item.icon}</ListItemIcon>
              <ListItemText primary={item.text} />
            </ListItem>
          ))}
        </List>
      </div>
    );
  };

  return (
    <div>
      <IconButton color="secondary" onClick={toggleDrawer(true)}>
        <MoreHorizIcon fontSize="small" />
      </IconButton>
      <Drawer
        anchor={"bottom"}
        open={state.bottom}
        onClose={(e, r) => {
          setDrawerOpen(r);
        }}
        transitionDuration={{ enter: 500, exit: 250 }}
      >
        {list()}
      </Drawer>
    </div>
  );
}
